import {Component} from "@angular/core";

@Component({
    styleUrls: ['./login-container.component.less'],
    templateUrl: './login-container.component.html'
})
export class LoginContainerComponent {
    constructor(){}
}
